// EmployeeEarningsDeduction

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { ReportPageShell } from "../../components/ui/reportPageShell";
import { EMPLOYEE_CREDIT_DEBIT } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";

const EmployeeEarningsDeduction = () => {

    const [employeeEarningsDeductionData, setEmployeeEarningsDeductionData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
        const EmployeeEarningsDeductionColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "year",
            Header: "Year",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "month",
            Header: "Month",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "department",
            Header: "Department",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "credit",
            Header: "Credit",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "debit",
            Header: "Debit",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "amount",
            Header: "Amount",
            Cell: ({ value }) => value ?? "-",
        }
    ];

    return (
        <ReportPageShell title="Employee Credits & Debits Report " count={totalRecords}>

            <Reactable
                columns={EmployeeEarningsDeductionColumns}
                data={employeeEarningsDeductionData}
                setData={setEmployeeEarningsDeductionData}
                setTotalCount={setTotalRecords}
                url={EMPLOYEE_CREDIT_DEBIT}
                serverSide={true}
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isMonthYearRequired={true}
            />
        </ReportPageShell>
    );
}

export default EmployeeEarningsDeduction;